import { useState, useEffect } from 'react'

export default function useIsInViewport(
  ref: React.MutableRefObject<undefined>,
  windowPortion: number = 1
) {
  const [isInViewport, setInViewport] = useState(false)

  const handleElementVisibility = () => {
    if (!ref?.current) return

    const element = ref.current

    const rect = element.getBoundingClientRect()

    const isVisible =
      element.offsetTop <= window.scrollY + window.innerHeight * windowPortion &&
      rect.left < window.innerWidth &&
      rect.right > 0

    if (isVisible !== isInViewport) {
      setInViewport(isVisible)
    }
  }

  useEffect(() => {
    // Check visibility when component mounts
    handleElementVisibility()

    document.addEventListener('scroll', handleElementVisibility)
    return () => {
      document.removeEventListener('scroll', handleElementVisibility)
    }
  }, [])

  return isInViewport
}
